// extracted by mini-css-extract-plugin
export default {"kycPage":"KYC_kycPage__9SuEt","kycInner":"KYC_kycInner__05KHz","logo":"KYC_logo__lQl0x"};